import ClubDetails from "./ClubDetails";

export default ClubDetails;
